import React from "react";
import "./ButtonSpinner.css";
const ButtonSpinner = () => (
  <div className="button-spinner" />
);
export default ButtonSpinner;
